import { Checkbox, RadioInput } from '@mm/components';
import { useFormikContext } from 'formik';
import React from 'react';
import * as yup from 'yup';
import TextInput from '../../../../../../common/components/TextInput';
import './CancelQuestionary.pcss';

export const initialPollValues = {
  reason: undefined,
  solutions: '',
  returnLikelihood: undefined,
  feedback: '',
  isUnderstandingConsequences: false,
};

export const questionaryValidator = yup.object({
  reason: yup.string().required(),
  solutions: yup.string(),
  returnLikelihood: yup.string().required(),
  feedback: yup.string(),
  isUnderstandingConsequences: yup
    .bool()
    .oneOf([true], 'Field must be checked')
    .required(),
});

type Poll = yup.Asserts<typeof questionaryValidator>;

const reasons = [
  "I couldn't figure it out",
  "I'm using another service",
  "Chatbots just aren't for me",
  "I couldn't get any contacts",
  "I need features MobileMonkey doesn't support",
  "I'm having technical problems",
  "I don't use it enough",
  "It's too expensive",
  'Other (please specify)',
];

const returnLikelyhoods = [...Array(10).keys()]
  .map(x => x + 1)
  .map(x => String(x));

export const CancelQuestionary = () => {
  const formik = useFormikContext<Poll>();

  return (
    <div className="cancel-questionary__container">
      <div className="cancel-questionary__question">
        Please share your reasone for leaving:
      </div>
      <div>
        {reasons.map((r, idx) => (
          <RadioInput
            key={idx}
            checked={formik.values.reason === r}
            name={r}
            value={r}
            label={r}
            onChange={e => formik.setFieldValue('reason', e.target.value)}
          />
        ))}
      </div>
      <div className="cancel-questionary__question">
        Which other solutions will you use now?
      </div>
      <div className="cancel-questionary__feedback">
        <TextInput
          value={formik.values.solutions}
          onChange={v => formik.setFieldValue('solutions', v.target.value)}
          placeholder="Start typing..."
          multiline
          autosize={false}
        />
      </div>
      <div className="cancel-questionary__question">
        How likely are you to return?
      </div>
      <div className="cancel-questionary__return">
        {returnLikelyhoods.map(r => (
          <RadioInput
            key={`return-${r}`}
            checked={formik.values.returnLikelihood === r}
            name={r}
            value={r}
            label={r}
            onChange={e =>
              formik.setFieldValue('returnLikelihood', e.target.value)
            }
            className="cancel-questionary__reason-radio-input"
          />
        ))}
      </div>
      <div className="cancel-questionary__question">
        Anything else you’d like to share about your experience?
      </div>
      <div className="cancel-questionary__feedback">
        <TextInput
          value={formik.values.feedback}
          onChange={v => formik.setFieldValue('feedback', v.target.value)}
          placeholder="Start typing..."
          multiline
          autosize={false}
        />
      </div>
      <div className="cancel-questionary__understanding">
        <Checkbox
          isChecked={formik.values.isUnderstandingConsequences}
          onToggle={() =>
            formik.setFieldValue(
              'isUnderstandingConsequences',
              !formik.values.isUnderstandingConsequences,
            )
          }
        />
        I understand that I will lose all of my customers, all of my leads, and
        all my funnels.
      </div>
    </div>
  );
};
